import { Button, Select, Space, Tooltip } from 'antd';
import React, { useState } from 'react';

const projectTypeOptions = [
  { label: 'Work Project', value: 'work' },
  {
    label: 'Personal Interest',
    value: 'personal'
  },
  { label: 'School', value: 'education' }
];

const ProjectQuestionStep: React.FC<{
  next: () => Promise<void>;
  prev: () => void;
}> = ({ next }) => {
  const [projectTypeInput, setProjectTypeInput] = useState('');
  const shouldDisableNextButton = projectTypeInput === '';
  const [nextLoading, setNextLoading] = useState(false);

  return (
    <>
      <Space direction="vertical" style={{ marginTop: 20, marginBottom: 20 }}>
        <Select
          style={{ width: 300 }}
          onChange={(value) => setProjectTypeInput(value)}
          options={projectTypeOptions}
        />

        <Tooltip
          title={shouldDisableNextButton ? 'Please answer all questions' : ''}
          placement="right"
        >
          <Button
            type="primary"
            disabled={shouldDisableNextButton}
            onClick={() => {
              if (window.Intercom) {
                window.Intercom('update', { ProjectType: projectTypeInput });
              }
              setNextLoading(true);
              next().then(() => {
                setNextLoading(false);
              });
            }}
            loading={nextLoading}
          >
            Next
          </Button>
        </Tooltip>
      </Space>
    </>
  );
};

export default ProjectQuestionStep;
